import React, { memo } from 'react';
import cn from 'classnames';
import { safeJsonParse } from '../../utility/helperFunction';
const ReceiptFooter = ({ serverAppTheme }) => {
  const deviceinfo =   safeJsonParse(window.sessionStorage.getItem('auth') , {});
  if (!deviceinfo?.footerLines || deviceinfo?.footerLines?.length === 0) {
    return null;
  }
  return (
    <>
    <div
      className={cn("py-2 rounded  text-center")}
      style={{
        color: serverAppTheme?.primary_text || "#000",
        maxHeight: '105px',
        overflowY: 'auto',
        overflowX : 'hidden'
      }}
    >
      {deviceinfo?.footerLines?.map((line, index) => (
        <div key={index} className="fs_16 fw-500 w-100" style={{ lineHeight: '1.2' ,wordBreak:'break-all' }}>
          {line}
        </div>
      ))}
    </div>
    </>
  );
};

export default memo(ReceiptFooter);
